export const getAdPreviewSinglePlacementLayoutStyles = (/* components, { palette = {} } = {} */) => ({
  adPreviewLayoutContainer: {
  },
});
